import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link } from 'react-router';
import { FormattedDate } from 'react-intl';

import Grid from '../Grid';

import './styles.css';

const formatPhoneNumber = (phoneNumber) => {
  let formattedPhoneNumber = phoneNumber;

  if (formattedPhoneNumber) {
    formattedPhoneNumber = formattedPhoneNumber.replace(/[^\d]/g, '');
    if (formattedPhoneNumber.length === 7) {
      return formattedPhoneNumber.replace(/(\d{3})(\d{4})/, '$1-$2');
    }

    if (formattedPhoneNumber.length === 10) {
      return formattedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }

    if (formattedPhoneNumber.length === 11) {
      return formattedPhoneNumber.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 $2-$3-$4');
    }
  }

  return formattedPhoneNumber;
};

class FairDetails extends React.PureComponent {
  static propTypes = {
    schoolPhone: PropTypes.string,
    primaryContact: PropTypes.shape({
      mail: PropTypes.string,
    }).isRequired,
    schoolAddress: PropTypes.shape({
      city: PropTypes.string,
      state: PropTypes.string,
      street: PropTypes.string,
      zipCode: PropTypes.string,
    }).isRequired,
    collegeFair: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      cost: PropTypes.string,
      endTime: PropTypes.string,
      numberOfExpectedStudents: PropTypes.number,
      startTime: PropTypes.string,
      webInstructions: PropTypes.string,
    }).isRequired,
  };

  render() {
    const { schoolPhone, schoolAddress, primaryContact, collegeFair } = this.props;

    const mailto = get(primaryContact, 'mail');
    let primaryMail = get(primaryContact, 'mail');
    if (primaryMail && primaryMail.length > 26) {
      const diff = (primaryMail.length - 26);
      const atIndex = primaryMail.indexOf('@');
      primaryMail = primaryMail.replace(primaryMail.slice(atIndex-diff, atIndex), '...');
    }
    const primaryPhoneNumber = formatPhoneNumber(schoolPhone);
    const primaryMailLink = primaryMail && <Link href={`mailto:${mailto}`}>{primaryMail}</Link>;

    return (
      <div>
        <Grid padded>
          <Grid.Row styleName="info-row">
            <Grid.Column textAlign="left" styleName="cell" mobile={16} tablet={8} computer={4}>
              <div>
                <FormattedDate
                  value={`${collegeFair.date}T12:00:00`}
                  year="numeric"
                  month="numeric"
                  day="numeric"
                />
              </div>
              <div styleName="scheduled-times">{collegeFair.startTime} - {collegeFair.endTime}</div>
            </Grid.Column>
            <Grid.Column textAlign="left" styleName="cell" mobile={16} tablet={8} computer={4}>
              <div>{schoolAddress.street}</div>
              <div>{schoolAddress.city}, {schoolAddress.state} {schoolAddress.zipCode}</div>
            </Grid.Column>
            <Grid.Column textAlign="left" styleName="cell phone" mobile={16} tablet={8} computer={4}>
              <div styleName="secondary-content">{primaryPhoneNumber}</div>
              <div>{primaryMailLink}</div>
            </Grid.Column>
            <Grid.Column textAlign="left" styleName="cell students-cost" mobile={16} tablet={8} computer={4}>
              <div styleName="secondary-content">{collegeFair.numberOfExpectedStudents} Students Expected</div>
              <div styleName="secondary-content">{collegeFair.cost} Cost</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {collegeFair.webInstructions}
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default FairDetails;
